import {Launch} from '@carbon/icons-react';
import {Box, Stack, Typography, useTheme} from '@mui/material';
import {ResourceTileTypes} from 'components/ResourceGrid/ResourceGrid';

type ResourceTileProps = {
  title: string;
  type: string;
  link?: string;
  onTileClick: (type: string, link?: string) => void;
};

export const ResourceTile = ({title, link, type, onTileClick}: ResourceTileProps) => {
  const theme = useTheme();

  return (
    <Box
      height='126px'
      width='146px'
      padding='10px'
      position='relative'
      justifyContent='flex-start'
      display='flex'
      alignItems='center'
      onClick={() => onTileClick(type, link)}
      sx={{
        bgcolor: theme.palette.grey[200],
        border: `1px solid ${theme.palette.grey[500]}`,
        boxShadow: '0px 2px 4px 0px #0000001A',
        borderRadius: '4px',
        cursor: 'pointer',
        '&:hover': {
          bgcolor: theme.palette.grey[100],
        },
      }}
    >
      <Stack width='100%' spacing='7px'>
        <Box
          width='100%'
          display='flex'
          minWidth='18px'
          minHeight='18px'
          alignItems='flex-end'
          justifyContent='flex-end'
          position='absolute'
          top='10px'
          right='10px'
        >
          {type === ResourceTileTypes.Link && <Launch height='18px' width='18px' color={theme.palette.grey[800]} />}
        </Box>
        <Box flex={1} pr='5px'>
          <Typography variant='h5' textAlign='left' lineHeight='135%'>
            {title}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};
